// import { env } from "./config";

export const SLIDER_IMAGE_1 = require("./assets/display-1.png");
export const SLIDER_IMAGE_2 = require("./assets/display-2.png");
export const SLIDER_IMAGE_3 = require("./assets/display-3.png");
export const SLIDER_IMAGE_4 = require("./assets/AppImage7.png");

// export const SLIDER_IMAGE_1 =
//   env === "prod"
//     ? require("./assets/image1.png")
//     : require("./assets/display-1.png");
// export const SLIDER_IMAGE_2 =
//   env === "prod"
//     ? require("./assets/AppImage1.png")
//     : require("./assets/display-2.png");
// export const SLIDER_IMAGE_3 =
//   env === "prod"
//     ? require("./assets/AppImage2.png")
//     : require("./assets/display-3.png");
// export const SLIDER_IMAGE_4 =
//   env === "prod"
//     ? require("./assets/AppImage7.png")
//     : require("./assets/AppImage7.png");
export const MAIN_LOGO_BIG = require("./assets/NewLogo/LogoBig.png");
export const MAIN_LOGO_OPTION_2 = require("./assets/NewLogo/LogoBig2.png");
